export var MatchAttributeType;
(function (MatchAttributeType) {
    MatchAttributeType["Sport"] = "Sport";
    MatchAttributeType["League"] = "League";
    MatchAttributeType["Region"] = "Region";
    MatchAttributeType["Organisation"] = "Organisation";
    MatchAttributeType["Venue"] = "Venue";
    MatchAttributeType["Round"] = "Round";
    MatchAttributeType["Season"] = "Season";
})(MatchAttributeType || (MatchAttributeType = {}));
//# sourceMappingURL=Types.js.map